export const meta: BlockMeta = {
  title: "File Item",
  description: "A single file item",
  keywords: ["downloads", "files", "content"],
  icon: "format-gallery",
  category: "media",
}

import { Button, ChipButton } from "@components/controls/Button"
import { FileItem } from "@components/media/FileItem"
import { IconLock, IconPaper } from "@components/svg/Icons"
import clsx from "clsx"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("content/file-item", (props) => {
  const url = props.type === "link" ? props.url : props.file?.mediaItemUrl

  return (
    <div>
      <FileItem
        className={env.admin && !url ? "!text-error-dark" : "!text-black"}
        href={url!}
        icon={props.icon ?? "file"}
        target="_blank"
        title={<EditableText store="file-name" inlineToolbar={false} placeholder="Example file name" appendOnEnter />}
        chips={
          <Button as="span" variant="outline" size="chip">
            <EditableText
              store="buttonLabel"
              inlineToolbar={false}
              defaultValue="Download"
              placeholder="Download"
              appendOnEnter
            />
          </Button>
        }
      />
    </div>
  )

  return (
    <div className={clsx()}>
      <div className="flex gap-1 flex-col items-center">
        <Link
          href={!env.admin ? props.file?.mediaItemUrl || "" : undefined}
          target="_blank"
          rel="noreferrer noopener"
          className="*:w-fileItem *:h-auto"
        >
          <IconPaper />
        </Link>
        <EditableText
          className="!type-title-s-medium w-full text-center"
          as="p"
          store="file-name"
          inlineToolbar={false}
          defaultValue="Example file name"
          placeholder="Example file name"
          appendOnEnter
        />
      </div>
      <div className="flex gap-1 justify-center flex-wrap"></div>
    </div>
  )
})
